import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './ResyRewardsTerms.scss';

const ResyRewardsTerms = ({ termsConfig }) => {
  const {
    section_id: sectionId,
    content = [],
  } = termsConfig || {};

  const blocks = content.filter(Boolean);
  if (blocks.length === 0) return null;

  return (
    <section className="ResyRewardsTerms" id={sectionId || undefined}>
      <div className="container">
        {blocks.map((block) => (
          <div
            key={block}
            className="ResyRewardsTerms__block"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: sanitizeString(block) }}
          />
        ))}
      </div>
    </section>
  );
};

ResyRewardsTerms.propTypes = {
  termsConfig: PropTypes.shape({
    section_id: PropTypes.string,
    content: PropTypes.arrayOf(PropTypes.string),
  }),
};

ResyRewardsTerms.defaultProps = {
  termsConfig: null,
};

export default ResyRewardsTerms;
